module.exports = __webpack_public_path__ + "media/images/add-fa5d8c3dacba0989132ee281b7359a2e.png";